import { useEffect, useRef } from "react";
import { CalendarCheck } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";
import { CLINIC } from "../data/clinic";

export const Booking = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const scriptSrc = "https://assets.calendly.com/assets/external/widget.js";
    let script = document.querySelector(`script[src="${scriptSrc}"]`);

    if (!script) {
      script = document.createElement("script");
      script.src = scriptSrc;
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <section
      id="booking"
      data-testid="booking-section"
      className="py-24 sm:py-32 bg-sa-cream"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <Reveal className="flex justify-center">
            <SectionLabel testId="booking-label">Reserve your visit</SectionLabel>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-sa-espresso mt-6">
              Book your pet&rsquo;s visit
              <span className="italic text-sa-bronze"> in seconds</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="font-body text-base sm:text-lg text-sa-mocha mt-6 leading-relaxed">
              Pick a time that works for you and your companion. For urgent
              emergencies, please call us straight away — we&rsquo;re open 24/7.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <div className="bg-sa-beige rounded-[32px] p-3 sm:p-5 border border-sa-espresso/5 shadow-[0_20px_60px_-30px_rgba(59,42,32,0.4)]">
            <div className="flex items-center gap-2 px-4 py-3 text-sa-mocha">
              <CalendarCheck className="w-4 h-4 text-sa-bronze" />
              <span className="font-body text-sm font-medium">
                Live scheduling · powered by Calendly
              </span>
            </div>
            <div
              ref={containerRef}
              data-testid="calendly-widget"
              className="calendly-inline-widget bg-sa-cream rounded-3xl overflow-hidden"
              data-url={CLINIC.calendlyUrl}
              style={{ minWidth: "320px", height: "700px" }}
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Booking;
